@if (rule) {
  <rask-selector
    [placeholder]="placeholder"
    class="cell"
    [(ngModel)]="value"
    [viewFormatter]="viewFormatter"
    [formatter]="formatter"
    [values]="values"
    [portalToBody]="false"
    [style.width]="actualCellWidth"
    (change)="onChange($event)"
    [disabled]="readonly">
  </rask-selector>
}
@if (!rule) {
  <rask-selector
    [placeholder]="placeholder"
    class="cell"
    [(ngModel)]="value"
    [viewFormatter]="viewFormatter"
    [formatter]="formatter"
    [values]="values"
    [portalToBody]="false"
    [style.width]="actualCellWidth"
    (change)="onChange($event)"
    [disabled]="readonly">
  </rask-selector>
}
